// extracted by mini-css-extract-plugin
module.exports = {"modal":"EditEnergyProModal_modal__2eAw6","arrow":"EditEnergyProModal_arrow__3KM-m","title":"EditEnergyProModal_title__NGICJ"};